import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css';
import InputBoxLarge from '../../common/InputBox/InputBoxLarge';
import InputBoxSmall from '../../common/InputBox/InputBoxSmall';
import SelectBoxLarge from '../../common/SelectBox/SelectBoxLarge';
import SelectBoxSmall from '../../common/SelectBox/SelectBoxSmall';
import InputAndSelectCompoBoxSmall from '../../common/InputBox/InputAndSelectCompo';
import TextBox from '../../common/TextBox/TextBox';
import UploadBox from '../../common/InputBox/UploadBox';
import UploadBoxCountry from '../../common/InputBox/UploadCountry';
import InputAndSelectWithIconBoxSmall from '../../common/InputBox/InpuSelectIcon';
import SearchSelectBox from '../../common/SelectBox/SelectBoxWithSearch';
import LargeInputBoxWithIcon from '../../common/InputBox/LargeInputWithIcon';
import FeaturesList from '../../common/FeaturesListAdd/FeaturesListAdd';
import ToggleSwitch from '../../common/ToggleButton/ToggleSwitch';
import SearchSelect from '../../common/SelectBox/searchSelect';
import SearchSelectBoxDrown from '../../common/SelectBox/searchSelect';
import PhoneInputSelect from '../../common/SelectBox/PhoneInputSelect';
import SelectBoxWithSearchTimezone from '../../common/SelectBox/SelectBoxWithSearchTimezone';
import SearchSelectTimezone from '../../common/SelectBox/SelectBoxWithSearchTimezone';


const AddPopup = ({ isOpen, title, buttonName, fields, onSave, onClose, popupErrorMessage }) => {

  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});


  useEffect(() => {
    if (!isOpen) {
      // Clear form values and errors when popup is closed
      setFormValues({});
      setFormErrors({});
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value,
    }));
  
    // Remove the error only if it was present
    if (formErrors[field]) {
      setFormErrors(prev => {
        const updatedErrors = { ...prev };
        delete updatedErrors[field];
        return updatedErrors;
      });
    }
  };
  
  const handleSelectChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value,
    }));
    
    // Clear error when field is modified
    setFormErrors(prev => ({
      ...prev,
      [field]: null,
    }));
  };

  const validateField = (field) => {
    const fieldValidators = field.validators || [];
    // const value = formValues[field.name] || field.defaultValue || "";
    const value = formValues[field.name] ?? "";
    
    // Run all validators for the field
    for (const validator of fieldValidators) {
      const result = validator(value);
      if (typeof result === 'string') {
        return result; // Return the first error message
      }
    }
    
    return null; // No errors
  }


  const handleSubmit = () => {
    // Clear existing errors first
    const newErrors = {};
    let hasErrors = false;
  
    fields.forEach((field) => {
      const errorMessage = validateField(field);
      if (errorMessage) {
        newErrors[field.name] = errorMessage;
        hasErrors = true;
      }
    });
  
    setFormErrors(newErrors); // override with new errors
  
    if (hasErrors) return;
  
    onSave(formValues);
  };
  
  // Helper function to render error message
  const renderErrorMessage = (fieldName) => {
    const error = formErrors[fieldName];
    return error ? (
      <div className="validation-error" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
        {error}
      </div>
    ) : null;
  };
  

  const handleClose = () => {

    setFormErrors({});
    if (onClose) onClose();
  };

  const renderField = (field, index) => {
    const commonProps = {
      key: index,
      ...field,
      error: formErrors[field.name],
    };
    
    switch (field.type) {
      case 'small-input':
        return (
          <div key={index} className="field-container w-50">
            <InputBoxSmall
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
            {/* {renderErrorMessage(field.name)} */}
          </div>
        );
      case 'large-input':
        return (
          <div key={index} className="field-container w-100">
            <InputBoxLarge
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
            {/* {renderErrorMessage(field.name)} */}
          </div>
        );
      case 'large-icon-input':
        return (
          <div key={index} className="field-container w-100">
            <LargeInputBoxWithIcon
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          </div>
        );


      // case 'large-select':
      //   return (
      //     <div key={index} className="field-container w-100">
      //       <SelectBoxLarge
      //         {...commonProps}
      //         onChange={(e) => handleInputChange(field.name, e.target.value)}
      //       />
      //       {renderErrorMessage(field.name)}
      //     </div>
      //   );

  case 'search-select': 
    return (
      <div key={index} className="field-container w-100">
        <SearchSelectBox 
          {...commonProps}
          allPlans={field.options || []}
          onChange={(selectedOptions) => {
            handleInputChange(field.name, selectedOptions);
          }}
        />
      </div>
    );
  case 'search-select-timezone': 
    return (
      <div key={index} className="field-container w-100">
        <SearchSelectTimezone
          {...commonProps}
          allPlans={field.options || []}
          onChange={(selectedOptions) => {
            handleInputChange(field.name, selectedOptions);
          }}
        />
      </div>
    );

      case 'large-select':
        return (
          <div key={index} className="field-container w-100">
            <SearchSelectBoxDrown
              {...commonProps}
              field={field}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          </div>
        );
        
      case 'small-select':
        return (
          <div key={index} className="field-container w-50">
            <SearchSelectBoxDrown
              {...commonProps}
              className='w-48'
              field={field}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          </div>
        );
      case 'upload-box':
        return (
          <div key={index} className="field-container w-100">
            <UploadBox 
              {...commonProps}
              onFileChange={(file) => handleInputChange(field.name, file)}
            />
          </div>
        );
      case 'upload-box-country':
        return (
          <div key={index} className="field-container w-100">
            <UploadBoxCountry 
              {...commonProps}
              onFileChange={(file) => handleInputChange(field.name, file)}
            />
          </div>
        );
      case 'custom':
        return (
          <div key={index} className="field-container custom-field-container">
            {field.component({
              ...commonProps,
              onChange: (value) => handleInputChange(field.name, value)
            })}
            {renderErrorMessage(field.name)}
          </div>
        );
        case 'input-select-combo-small':
          return (
            <div key={index} className="field-container w-50">
              <InputAndSelectCompoBoxSmall
                {...commonProps}
                label={field.label}
                options={field.options}
                defaultValue={field.defaultValue}
                defaultOption={field.defaultOption}
                validators={field.validators}
                error={formErrors[field.name]} 
                onChange={(e) => handleInputChange(field.name, e.target.value)}
                selectchange={(e) => handleInputChange(field.select, e.target.value)} 
              />
            </div>
          );        
      case 'features-list':
        return (
          <div key={index} className="field-container w-100">
            <FeaturesList
              {...commonProps}
              title={field.label}
              onChange={(selectedFeatures) => {
                handleInputChange(field.name, selectedFeatures);
              }}
              error={formErrors[field.name]}
              validators={field.validators}
            />
          </div>
        );
      case 'input-select-icon':
        return (
          <div key={index} className="field-container w-50">
            <InputAndSelectWithIconBoxSmall
              {...commonProps}
              onChange={({ type, value }) => {
                if (type === 'input') {
                  handleInputChange(field.name, value); 
                } else if (type === 'select') {
                  handleSelectChange(field.opt, value); 
                }
              }}
            />
          </div>
        );
      case 'text':
        return (
          <div key={index} className="field-container w-100">
            <TextBox 
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          </div>
        );
      case 'small-date':
      case 'small-time':
        return (
          <div key={index} className="field-container w-50">
            <InputBoxSmall
              {...commonProps}
              type={field.type}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          </div>
        );
      case 'date':
      case 'time':
        return (
          <div key={index} className="field-container w-100">
            <InputBoxLarge
              {...commonProps}
              type={field.type}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
            />
          </div>
        );
      case 'search-select': 
        return (
          <div key={index} className="field-container w-100">
            <SearchSelectBox 
              {...commonProps}
              allPlans={field.options || []}
              onChange={(selectedOptions) => {
                handleInputChange(field.name, selectedOptions);
              }}
            />
          </div>
        );

        case 'phone-input': 
        return (
          <div key={index} className="field-container w-100">
            <PhoneInputSelect
              {...commonProps}
              onChange={(e) => handleInputChange(field.name, e.target.value)}
              iconType={field?.iconType}
            />
          </div>
        );

      case 'toggle':
        return (
          <div key={index} className="toggle-container-pop w-100">
              <span className='fts-12 ftw-4' style={{color:"#6D6D6D",marginLeft:"5px"}}>{field.label}</span>
            <ToggleSwitch 
              onToggle={(value) => handleInputChange(field.name, value)}
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup add-popup popup1">
        <CloseButton onClick={handleClose}  />
        {popupErrorMessage && (
          <div className="popup-error-message fts-13" style={{ color: 'red', marginBottom: '10px' }}>
            {popupErrorMessage}
          </div>
        )}
        <div className="popup-name-button">
          <h2 className="popup-name fts-17 common-text ftw-5 black">{title}</h2>
          <button className="popup-add-button common-text white fts-15 ftw-5" onClick={handleSubmit}>{buttonName}</button>
        </div>
        <div className="add-input-box-container ai-center">
          {fields.map((field, index) => renderField(field, index))}
        </div>
      </div>
    </div>
  );
};

AddPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddPopup;